import { useQuery } from "@tanstack/react-query"
import { generateOutlookAuthLinkQuery } from "modules/settings/lib/outlook/generateOutlookAuthLinkQuery"

export function useGenerateOutlookAuthLinkQuery(
  ...args: Parameters<typeof generateOutlookAuthLinkQuery>
) {
  return useQuery(generateOutlookAuthLinkQuery(...args))
}
